import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import { report_delivery_tax_invoice, report_delivery_note, report_receipt } from "../../../components/Report.js"
export default class Payments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create_credit_note: false,
      modal_view_credit_note: false,

      data_sale: [],
      data_customer: [],
      data_bank: [],
      data_product: [],

      tab: "normal",

      uid: "",
      sale_uid: "",
      date: "",
      due_date: format_date(new Date(), "yyyy-mm-dd", "en"),
      customer_id: "",
      address: "",
      withdrawal_type: "",
      phone_number: "",
      payment_type: "",
      tax_number: "",
      receipt_type: "",
      sale_document_no: "",

      transaction_list: [],
      transaction_list_vat: [],
      credit_note: [],

      is_vat: false,
      discount: 0,
      delivery_cost: 0,

      amount_deposit: 0,
      amount_deposit_need: 0,
      total_pay: 0,

      // เงินสด
      cash_amount: 0,
      // เงินโอน
      transfer_amount: 0,
      transfer_bank_account: "",
      transfer_date: "",
      transfer_time: "",
      // เครดิต
      credit_amount: 0,
      credit_bank_account: "",
      credit_date: "",
      check_number: "",

      amount: 0,
      count_item: 0,
      reason: "",
      status: "",
      remark: "",
      transaction_credit_note: [],
    };
  }

  async componentDidMount() {
    loading(true);
    await this.Get();
    if (params("id")) {
      await this.GetByID(params("id"));
    }

    loading(false);
  }
  Get = async () => {
    let data_customer, data_sale, data_bank, data_product;
    let [result_customer, result_sale, result_bank, result_product] =
      await Promise.all([
        GET("admin/setting/customers/list", { page: 0, data_search: "" }),
        GET("admin/invoices/list", {
          page: 0,
          status_code: "รอชำระ",
        }),
        GET("admin/setting/banks/list", { page: 0, data_search: "" }),
        GET("admin/setting/spare-parts/list", { page: 0, data_search: "" }),
      ]);
    if (result_customer?.status) {
      
      data_customer = result_customer.data.map((e) => ({
        value: e.uid,
        label: `${e.full_name}${e.customer_code ? ` ${e.customer_code} | ` : ""}${e.phone ? ` (${e.phone}) ` : ""} ${
            e.address ? ` | ${e.address}` : ""
          }`,
      }));
    }
    if (result_sale?.status) {
      data_sale = result_sale.data.map((e) => ({
        value: e.uid,
        label: e.document_no,
      }));
    }
    if (result_bank?.status) {
      data_bank = result_bank.data.map((e) => ({
        value: e.uid,
        label: `${e.bank_name} : ${e.account_number} (${e.account_name})`,
      }));
    }
    if (result_product?.status) {
      data_product = result_product.data.map((e) => ({
        value: e.uid,
        label: `${e.product_code} ${e.product_name}`,
        id: e.id,
        warehouse_id: e.warehouse?.uid || "",
        unit_name: e.unit_name,
        is_serial_number: e.is_serial_number,
        product_code: e.product_code,
        product_name: e.product_name,
        sale_price: e.sale_price,
      }));
    }
    this.setState({
      data_customer,
      data_sale,
      data_bank,
      data_product,
    });
  };
  GetByID = async (id) => {
    const { data_product } = this.state;
    loading(true);
    let result = await GET("admin/invoices/list", { uid: id });
    
    let item = result.data;
    if (item) {
      if (item.sale) {
        this.setState({
          ...item,
          uid: item.uid,
          sale_uid: item.sale?.uid || "",
          sale_document_no: item.sale?.document_no || "",
          date: item.created_at ? item.created_at.split("T")[0] : "",
          due_date: item.sale.due_date
            ? item.sale.due_date
            : item.sale.payment_type === "ชำระเงินเชื่อ"
            ? format_date(
                new Date(
                  new Date(item.created_at).setMonth(
                    new Date(item.created_at).getMonth() + 1
                  )
                ),
                "yyyy-mm-25",
                "en"
              )
            : format_date(new Date(), "yyyy-mm-dd", "en"),
          // customer
          customer_id: item.sale?.customer?.uid,
          address: item.sale?.customer?.address,
          phone_number: item.sale?.customer?.phone,
          tax_number: item.sale?.customer?.tax_number,

          withdrawal_type: item.sale?.withdrawal_type,
          payment_type: item.sale?.payment_type,
          receipt_type: item.sale?.receipt_type,

          transaction_list: item.sale?.transaction_list,
          transaction_list_vat: item.sale?.transaction_list_vat?.map((e) => ({
            ...e,
            product_id:
              data_product.find((p) => p.product_code === e.product_code)
                ?.value || "",
          })),
          credit_note:
            item.credit_note.filter((e) => e.status !== "ยกเลิก") || [],
          is_vat: item.sale?.is_vat,
          discount: item.sale?.discount,

          amount_deposit: Number(item.sale?.amount_deposit),
          total_pay: Number(item.sale?.total_pay),
        });
      } else if (item.repair) {
        this.setState({
          ...item,
          uid: item.uid,
          sale_uid: item.repair?.uid || "",
          sale_document_no: item.repair?.document_no || "",
          date: item.created_at ? item.created_at.split("T")[0] : "",
          due_date: item.repair.due_date
            ? item.repair.due_date
            : item.repair.payment_type === "ชำระเงินเชื่อ"
            ? format_date(
                new Date(
                  new Date(item.created_at).setMonth(
                    new Date(item.created_at).getMonth() + 1
                  )
                ),
                "yyyy-mm-25",
                "en"
              )
            : format_date(new Date(), "yyyy-mm-dd", "en"),
          // customer
          customer_id: item.repair.customer.uid,
          address: item.repair.customer.address,
          phone_number: item.repair.customer.phone,
          tax_number: item.repair.customer.tax_number,

          withdrawal_type: item.repair.withdrawal_type,
          payment_type:
            item.repair.payment_type === "ชำระเชื่อ"
              ? "ชำระเงินเชื่อ"
              : item.repair.payment_type,
          receipt_type: item.repair.receipt_type,

          transaction_list: !item.transaction_list
            ? item.repair.stock_activity_list
                .map((e) => e.transaction_list)
                .flat()
            : item.transaction_list,
          transaction_list_vat: item.repair.transaction_list_vat?.map((e) => ({
            ...e,
            product_id:
              data_product.find((p) => p.product_code === e.product_code)
                ?.value || "",
          })),
          credit_note: item.credit_note || [],
          is_vat: item.repair.is_vat,
          discount: item.repair.discount,

          amount_deposit: Number(item.repair.amount_deposit),
          total_pay: Number(item.repair.total_pay),
        });
      }
    }

    loading(false);
  };
  CreateUpdate = async () => {
    const {
      data_bank,
      uid,
      sale_uid,
      warehouse_id,
      ref_number,
      user_id,
      customer_id,
      phone_number,
      discount,
      is_vat,
      vat,
      delivery_cost,
      status,
      remark,
      due_date,
      withdrawal_type,
      payment_type,
      receipt_type,
      transaction_list,
      transaction_list_vat,
      amount_deposit,
      amount_deposit_need,
      cash_amount,
      transfer_amount,
      credit_amount,
      total_pay,
      transfer_bank_account,
      transfer_date,
      transfer_time,
      credit_bank_account,
      credit_date,
      check_number,

      credit_note,
    } = this.state;
    if (!customer_id.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกลูกค้า");
      return;
    }
    if (!due_date) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกวันที่ครบกำหนด");
      return;
    }
    if (!withdrawal_type) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกประเภทการเบิก");
      return;
    }
    if (!payment_type) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกประเภทการชำระ");
      return;
    }
    if (!receipt_type) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกประเภทใบเสร็จ");
      return;
    }

    let _total = 0;
    const vatRate = is_vat ? 0.07 : 0;

    if (transaction_list_vat.length > 0) {
      transaction_list_vat.forEach((item) => {
        const qty = Number(item.qty ?? 0);
        const unitPrice = Number(item.unit_price ?? 0);
        const itemDiscount = Number(item.discount ?? 0);
        _total += qty * (unitPrice - itemDiscount);
      });
    } else {
      transaction_list.forEach((item) => {
        const qty = Number(item.qty ?? 0);
        const unitPrice = Number(item.unit_price ?? 0);
        const itemDiscount = Number(item.discount ?? 0);
        _total += qty * (unitPrice - itemDiscount);
      });
    }

    if (isNaN(_total)) _total = 0;

    const billDiscount = Number(discount ?? 0); // ส่วนลดทั้งบิล
    const net = _total - billDiscount - total(credit_note, "amount");
    const _vat = net * vatRate;
    let grandTotal = net + _vat - Number(total_pay);
    grandTotal = Number(toFixed(grandTotal).replaceAll(",",""))

    let total_pay_amount = Number(cash_amount) + Number(transfer_amount) + Number(credit_amount);
    total_pay_amount = Number(toFixed(total_pay_amount).replaceAll(",",""))
    if (0 < total_pay_amount && Number(toFixed(grandTotal).replaceAll(",","")) < Number(toFixed(total_pay_amount).replaceAll(",",""))) {
      alert("", "warning", "แจ้งเตือน", "ยอดชำระเกินมูลค่าเต็มจำนวนสั่งซื้อ");
      return;
    }
    if (Number(total_pay) === 0) {
      if (Number(amount_deposit_need) + Number(amount_deposit) === 0) {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          "ยอดเงินที่ต้องการชำระ ต้องมากกว่า 0"
        );
        return;
      }

      if (
        total_pay_amount !==
        Number(amount_deposit_need) + Number(amount_deposit)
      ) {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          "ยอดเงินรวมไม่เท่ากับยอดเงินที่ต้องการชำระ"
        );
        return;
      }
    } else {
      if (Number(amount_deposit_need) === 0) {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          "ยอดเงินที่ต้องการชำระ ต้องมากกว่า 0"
        );
        return;
      }

      if (total_pay_amount !== Number(amount_deposit_need)) {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          "ยอดเงินรวมไม่เท่ากับยอดเงินที่ต้องการชำระ"
        );
        return;
      }
    }
    let _status = "ใบแจ้งหนี้";
    if (_status === "ใบแจ้งหนี้") {
      if (total_pay_amount === 0) {
        _status = "ใบแจ้งหนี้";
      } else if (Number(grandTotal) <= Number(total_pay_amount)) {
        _status = "เสร็จสิ้น";
      } else {
        _status = "ใบแจ้งหนี้";
      }
    } else {
      if (Number(grandTotal) <= Number(total_pay_amount)) {
        _status = "เสร็จสิ้น";
      } else {
        _status = "ใบแจ้งหนี้";
      }
    }

    loading(true);
    let body = {
      is_vat,
      customer_id: customer_id,
      phone_number: phone_number,
      due_date: due_date,
      withdrawal_type: withdrawal_type,
      payment_type: payment_type,
      receipt_type: receipt_type,

      transaction_list_vat: transaction_list_vat,

      status: _status,
      amount_deposit: Number(amount_deposit),

      payment: {
        cash_amount: Number(cash_amount),
        transfer_amount: Number(transfer_amount),
        transfer_bank_account: transfer_bank_account,
        transfer_date: transfer_date || null,
        transfer_time: transfer_time,
        credit_amount: Number(credit_amount),
        credit_bank_account: credit_bank_account,
        credit_date: credit_date || null,
        check_number: check_number,
        change: 0,
      },
    };

    let result = await PUT("admin/sales/update/" + sale_uid, body);
    if (result?.status) {
      // alert("/invoice/invoices", "success");
      const _transfer_bank_account = data_bank.find(e=>e.value === transfer_bank_account)
      const _credit_bank_account = global.bank.find(e=>e.value === credit_bank_account)
      Swal.fire({
        title: "พิมพ์เอกสาร",
        text: "",
        html: `
          <div class="w-100">
            <button id="report-delivery-tax-invoice" class="btn btn-outline-dark w-100 mb-3 text-start">
              <span class="icon me-2">&#xf15b;</span>
              ใบส่งของ/ใบกำกับภาษี
            </button>
            <button id="report-delivery-note" class="btn btn-outline-dark w-100 mb-3 text-start">
              <span class="icon me-2">&#xf15b;</span>
              ใบส่งของ
            </button>
            <button id="report-receipt" class="btn btn-outline-dark w-100 mb-3 text-start">
              <span class="icon me-2">&#xf15b;</span>
              ใบเสร็จรับเงิน
            </button>
          </div>
        `,
        showConfirmButton: false,
        showCancelButton: false,
        showCloseButton: true,
      didOpen: () => {
        document.getElementById("report-delivery-tax-invoice").addEventListener("click", () => {
          report_delivery_tax_invoice(uid);
        });

        document.getElementById("report-delivery-note").addEventListener("click", () => {
          report_delivery_note(uid);
        });

        document.getElementById("report-receipt").addEventListener("click", () => {
          report_receipt(uid, {
            type: "invoice",
            cash_amount: cash_amount,
            transfer_amount: transfer_amount,
            transfer_bank_account: _transfer_bank_account?.label || "",
            transfer_date: transfer_date,
            transfer_time: transfer_time,
            credit_amount: credit_amount,
            credit_bank_account: _credit_bank_account?.label || "",
            credit_date: credit_date,
            check_number: check_number,
          });
        });
      },
      }).then((res) => {
        if (res.dismiss) {
          window.location.href = "/invoice/invoices";
        }
      });
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
    }
    loading(false);
  };
  CreateUpdateCreditNote = async () => {
    const {
      uid,
      amount,
      count_item,
      reason,
      status,
      remark,
      transaction_credit_note,
      data_product,
    } = this.state;
    if (!transaction_credit_note.some((e) => e.checked)) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกอย่างน้อย 1 รายการ");
      return;
    }
    if (!reason) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเหตุผลการลดหนี้");
      return;
    }
    let _total = 0;
    for (let item of transaction_credit_note) {
      _total += (Number(item.credit_unit_price) * Number(item.credit_qty));
    }
    // if (_total === 0) {
    //   alert("", "warning", "แจ้งเตือน", "กรุณากรอกราคาต่อหน่วย");
    //   return;
    // }
    loading(true);
    let body = {
      invoice_id: uid,
      amount: _total,
      count_item: transaction_credit_note.filter((e) => e.checked).length,
      reason,
      status: "",
      remark: reason,
      transaction_credit_note: transaction_credit_note.map((e) => ({
        ...e,
        serial_number: e.serial_number?.split(",").map((s) => s.trim()) || [],
        type: "ลดหนี้",
        qty: Number(e.credit_qty),
        unit_price: Number(e.credit_unit_price),
        amount: Number(e.credit_unit_price),
        product_id:
          data_product.find((p) => p.product_code === e.product_code)?.value ||
          "",
      })),
    };
    let result = await POST("admin/credit-notes/create", body);
    if (result?.status) {
      alert("#", "success");
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
    }
    loading(false);
  };
  DeleteDebt = async (id) => {
    const { uid } = this.state;
    if (
      await alert(
        "",
        "warning",
        "ลบข้อมูล",
        "ยืนยันการลบรายการนี้หรือไม่ ?",
        "ลบข้อมูล",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let result = await PUT("admin/credit-notes/update/" + id, {
        status: "ยกเลิก",
      });
      if (result?.status) {
        this.GetByID(uid);
      }
      loading(false);
    }
  };
  render() {
    const {
      modal_create_credit_note,
      modal_view_credit_note,

      data_sale,
      data_customer,
      data_bank,
      data_product,

      tab,

      uid,
      sale_uid,
      date,
      due_date,
      customer_id,
      address,
      withdrawal_type,
      phone_number,
      payment_type,
      tax_number,
      receipt_type,
      sale_document_no,

      transaction_list,
      transaction_list_vat,
      credit_note,
      is_vat,
      discount,

      amount_deposit,
      amount_deposit_need,
      total_pay,

      cash_amount,
      transfer_amount,

      transfer_bank_account,
      transfer_date,
      transfer_time,

      credit_amount,
      credit_bank_account,
      credit_date,
      check_number,

      amount,
      count_item,
      reason,
      status,
      remark,
      transaction_credit_note,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="d-flex justify-content-between mb-2">
            <h4 className="fw-bold mb-3 me-3">ใบแจ้งหนี้/ใบส่งของ</h4>
          </div>
          {/* รายการสินค้า */}
          <div className="rounded-4 bg-white p-3 mb-3">
            <div className="row mb-3">
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">เลขรายการรายการสั่งซื้อ</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="เลขรายการรายการสั่งซื้อ..."
                  onChange={(e) => {
                    this.setState({ sale_document_no: e.target.value });
                  }}
                  value={sale_document_no}
                  disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">วันที่ขายสินค้า</div>
                <input
                  type="date"
                  className="form-control"
                  placeholder="วันที่ขายสินค้า..."
                  onChange={(e) => {
                    this.setState({ date: e.target.value });
                  }}
                  value={date}
                  disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ชื่อลูกค้า</div>
                <Select
                  options={data_customer}
                  className="form-control"
                  placeholder="ชื่อลูกค้า..."
                  onChange={(e,i) => {
                    this.setState({ customer_id: e,
                      phone_number: i.phone,
                     });
                  }}
                  value={customer_id}
                  // disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ที่อยู่</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="ที่อยู่..."
                  onChange={(e) => {
                    this.setState({ address: e.target.value });
                  }}
                  value={address}
                  disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">เบอร์โทรศัพท์</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="เบอร์โทรศัพท์..."
                  onChange={(e) => {
                    if (!float(e.target.value)) return;
                    this.setState({ phone_number: e.target.value });
                  }}
                  value={phone_number}
                  maxLength={10}
                  disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ครบกำหนดชำระ</div>
                <input
                  type="date"
                  className="form-control"
                  placeholder="ครบกำหนดชำระ..."
                  onChange={(e) => {
                    this.setState({ due_date: e.target.value });
                  }}
                  value={due_date}
                  disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ประเภทการเบิก</div>
                <select
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ withdrawal_type: e.target.value });
                  }}
                  value={withdrawal_type}
                  disabled
                >
                  <option value="">เลือกประเภท</option>
                  <option value="ขายหน้าร้าน">ขายหน้าร้าน</option>
                  <option value="เบิกแจ้งซ่อม">เบิกแจ้งซ่อม</option>
                  <option value="รอสั่งสินค้า">รอสั่งสินค้า</option>
                </select>
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">รูปแบบบิลชำระ</div>
                <select
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ payment_type: e.target.value });
                  }}
                  value={payment_type}
                  disabled
                >
                  <option value="">เลือกรูปแบบบิลชำระ</option>
                  <option value="ชำระเงินทันที">ชำระเงินทันที</option>
                  <option value="ชำระมัดจำ">ชำระมัดจำ</option>
                  <option value="ชำระเงินเชื่อ">ชำระเงินเชื่อ</option>
                </select>
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ประเภทใบเสร็จ</div>
                <select
                  className="form-control"
                  onChange={(e) => {
                    this.setState({
                      receipt_type: e.target.value,
                      is_vat: e.target.value === "ต้องการ Vat" ? true : false,
                    });
                  }}
                  value={receipt_type}
                  disabled={params("type") === "view"}
                >
                  <option value="">เลือกรูปแบบบิลชำระ</option>
                  <option value="ไม่ต้องการ Vat">ไม่ต้องการ Vat</option>
                  <option value="ต้องการ Vat">ต้องการ Vat</option>
                  <option value="บันทึกออเดอร์">บันทึกออเดอร์</option>
                </select>
              </div>
            </div>
            <hr />
            <h5 className="fw-bold mb-3 me-3">รายการสินค้า</h5>
            <div className="d-flex mb-3">
              <div className="border-1 border-secondary rounded-4 p-1 d-flex bg-light">
                <button
                  className={`btn ${
                    tab === "normal" ? "btn-dark" : "btn-light"
                  } px-3`}
                  onClick={async () => {
                    this.setState({ tab: "normal" });
                  }}
                >
                  รายการขายปกติ
                </button>
                <div style={{ width: 4 }}></div>
                <button
                  className={`btn ${
                    tab === "vat" ? "btn-dark" : "btn-light"
                  } px-3`}
                  onClick={async () => {
                    this.setState({ tab: "vat" });
                  }}
                >
                  รายการขายมี Vat
                </button>
              </div>
            </div>
            {/* รายการขายปกติ */}
            {tab === "normal" && (
              <div>
                <div className="table-responsive">
                  <table className="table rounded-3 overflow-hidden table-hover">
                    <thead>
                      <tr>
                        <td className="text-nowrap">ลำดับ</td>
                        <td className="text-nowrap">รหัส/ชื่อสินค้า</td>
                        <td className="text-nowrap">Serial No.</td>
                        <td className="text-nowrap text-center">จำนวน</td>
                        <td className="text-nowrap text-center">ราคา/หน่วย</td>
                        <td className="text-nowrap text-center">ส่วนลด</td>
                        <td className="text-nowrap text-end">
                          ราคาหลังหักส่วนลด
                        </td>
                        <td className="text-nowrap text-end">มูลค่ารวม</td>
                      </tr>
                    </thead>
                    <tbody>
                      {transaction_list?.map((item, index) => (
                        <tr>
                          <td className="text-nowrap">{index + 1}</td>
                          <td className="text-nowrap">
                            {item.product_code} {item.product_name}{" "}
                            {item.remark}
                          </td>
                          <td className="text-nowrap">
                            {item.serial_number || ""}
                          </td>
                          <td className="text-nowrap">{toFixed(item.qty)}</td>
                          <td className="text-nowrap">
                            {toFixed(item.unit_price)}
                          </td>
                          <td className="text-nowrap">
                            {toFixed(item.discount)}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(
                              Number(item.unit_price) - Number(item.discount)
                            ) || "0.00"}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(
                              Number(item.qty) *
                                (Number(item.unit_price) -
                                  Number(item.discount))
                            ) || "0.00"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="rounded-4 bg-white p-3">
                  <div className="row">
                    <div className="col-12 col-md-6 mb-2"></div>
                    <div className="col-12 col-md-6 mb-2">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>รวมเป็นเงิน</b>
                        <span>
                          {(() => {
                            let total = 0;
                            transaction_list.forEach((item) => {
                              total +=
                                Number(item.qty) *
                                (Number(item.unit_price) -
                                  Number(item.discount));
                            });
                            if (isNaN(total)) total = 0;
                            return `${toFixed(total || 0)} บาท`;
                          })()}
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>ส่วนลด</b>
                        <span>{toFixed(discount || 0)} บาท</span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>ราคาหลังหักส่วนลด</b>
                        <span>
                          {(() => {
                            let total = 0;
                            transaction_list.forEach((item) => {
                              total +=
                                Number(item.qty) *
                                (Number(item.unit_price) -
                                  Number(item.discount));
                            });
                            if (isNaN(total)) total = 0;
                            return `${toFixed(total - discount || 0)}`;
                          })()}{" "}
                          บาท
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>ภาษีมูลค่าเพิ่ม 7%</b>
                        <span>
                          {(() => {
                            let total = 0;
                            const vatRate = is_vat ? 0.07 : 0;

                            transaction_list.forEach((item) => {
                              const qty = Number(item.qty ?? 0);
                              const unitPrice = Number(item.unit_price ?? 0);
                              const itemDiscount = Number(item.discount ?? 0);
                              total += qty * (unitPrice - itemDiscount);
                            });

                            if (isNaN(total)) total = 0;

                            const billDiscount = Number(discount ?? 0); // ส่วนลดทั้งบิล
                            const net = total - billDiscount;

                            const vat = net * vatRate;

                            return `${toFixed(vat)} บาท`;
                          })()}
                        </span>
                      </div>
                      <hr />
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>จำนวนเงินรวมทั้งหมด</b>
                        <h4 className="fw-bold text-success">
                          {(() => {
                            let total = 0;
                            const vatRate = is_vat ? 0.07 : 0;

                            transaction_list.forEach((item) => {
                              const qty = Number(item.qty ?? 0);
                              const unitPrice = Number(item.unit_price ?? 0);
                              const itemDiscount = Number(item.discount ?? 0);
                              total += qty * (unitPrice - itemDiscount);
                            });

                            if (isNaN(total)) total = 0;

                            const billDiscount = Number(discount ?? 0); // ส่วนลดทั้งบิล
                            const net = total - billDiscount;

                            const vat = net * vatRate;
                            const grandTotal = net + vat;

                            return `${toFixed(grandTotal)} บาท`;
                          })()}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {tab === "vat" && (
              <div>
                <div>
                  <table className="table rounded-3 table-hover">
                    <thead>
                      <tr>
                        <td className="text-nowrap">ลำดับ</td>
                        <td className="text-nowrap">รหัส/ชื่อสินค้า</td>
                        <td className="text-nowrap">Serial No.</td>
                        <td className="text-nowrap text-center">จำนวน</td>
                        <td className="text-nowrap text-center">ราคา/หน่วย</td>
                        <td className="text-nowrap text-center">ส่วนลด</td>
                        <td className="text-nowrap text-end">
                          ราคาหลังหักส่วนลด
                        </td>
                        <td className="text-nowrap text-end">มูลค่ารวม</td>
                      </tr>
                    </thead>
                    <tbody>
                      {transaction_list_vat?.map((item, index) => (
                        <tr>
                          <td className="text-nowrap">{index + 1}</td>
                          <td className="text-nowrap">
                            {item.product_code} {item.product_name}
                          </td>
                          <td className="text-nowrap">{item.serial_number}</td>
                          <td className="text-nowrap">{item.qty}</td>
                          <td className="text-nowrap">{item.unit_price}</td>
                          <td className="text-nowrap">{item.discount}</td>
                          <td className="text-nowrap text-end">
                            {toFixed(
                              Number(item.unit_price) - Number(item.discount)
                            ) || "0.00"}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(
                              Number(item.qty) *
                                (Number(item.unit_price) -
                                  Number(item.discount))
                            ) || "0.00"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="rounded-4 bg-white p-3">
                  <div className="row">
                    <div className="col-12 col-md-6 mb-2"></div>
                    <div className="col-12 col-md-6 mb-2">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>รวมเป็นเงิน</b>
                        <span>
                          {(() => {
                            let total = 0;
                            transaction_list_vat.forEach((item) => {
                              total +=
                                Number(item.qty) *
                                (Number(item.unit_price) -
                                  Number(item.discount));
                            });
                            if (isNaN(total)) total = 0;
                            return `${toFixed(total || 0)} บาท`;
                          })()}
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>ส่วนลด</b>
                        <span>{toFixed(discount || 0)} บาท</span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>ราคาหลังหักส่วนลด</b>
                        <span>
                          {(() => {
                            let total = 0;
                            transaction_list_vat.forEach((item) => {
                              total +=
                                Number(item.qty) *
                                (Number(item.unit_price) -
                                  Number(item.discount));
                            });
                            if (isNaN(total)) total = 0;
                            return `${toFixed(total - discount || 0)}`;
                          })()}{" "}
                          บาท
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>ภาษีมูลค่าเพิ่ม 7%</b>
                        <span>
                          {(() => {
                            let total = 0;
                            const vatRate = is_vat ? 0.07 : 0;

                            transaction_list_vat.forEach((item) => {
                              const qty = Number(item.qty ?? 0);
                              const unitPrice = Number(item.unit_price ?? 0);
                              const itemDiscount = Number(item.discount ?? 0);
                              total += qty * (unitPrice - itemDiscount);
                            });

                            if (isNaN(total)) total = 0;

                            const billDiscount = Number(discount ?? 0); // ส่วนลดทั้งบิล
                            const net = total - billDiscount;

                            const vat = net * vatRate;

                            return `${toFixed(vat)} บาท`;
                          })()}
                        </span>
                      </div>
                      <hr />
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>จำนวนเงินรวมทั้งหมด</b>
                        <h4 className="fw-bold text-success">
                          {(() => {
                            let total = 0;
                            const vatRate = is_vat ? 0.07 : 0;

                            transaction_list_vat.forEach((item) => {
                              const qty = Number(item.qty ?? 0);
                              const unitPrice = Number(item.unit_price ?? 0);
                              const itemDiscount = Number(item.discount ?? 0);
                              total += qty * (unitPrice - itemDiscount);
                            });

                            if (isNaN(total)) total = 0;

                            const billDiscount = Number(discount ?? 0); // ส่วนลดทั้งบิล
                            const net = total - billDiscount;

                            const vat = net * vatRate;
                            const grandTotal = net + vat;

                            return `${toFixed(grandTotal)} บาท`;
                          })()}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* ใบลดหนี้ */}
          <div className="rounded-4 bg-white p-3 mb-3">
            <h5 className="fw-bold mb-3 me-3">ใบลดหนี้</h5>
            <div>
              <div className="table-responsive">
                <table className="table rounded-3 overflow-hidden table-hover">
                  <thead>
                    <tr>
                      <td className="text-nowrap">เลขที่ใบลดหนี้</td>
                      <td className="text-nowrap">วันที่ออกใบลดหนี้</td>
                      <td className="text-nowrap">เหตุผลการลดหนี้</td>
                      <td className="text-nowrap text-end">
                        จำนวนเงินที่ลดหนี้
                      </td>
                      <td className="text-nowrap"></td>
                    </tr>
                  </thead>
                  <tbody>
                    {credit_note?.map((item, index) => (
                      <tr>
                        <td className="text-nowrap">{item.document_no}</td>
                        <td className="text-nowrap">
                          {item.created_at ? format_date(item.created_at) : ""}
                        </td>
                        <td className="text-nowrap">{item.reason || ""}</td>
                        <td className="text-nowrap text-end">
                          {toFixed(item.amount)}
                        </td>

                        <td className="text-center align-middle wpx-100">
                          <div className="d-flex">
                            <BtnIcon
                              type="view"
                              onClick={() => {
                                this.setState({
                                  transaction_credit_note:
                                    item.transaction_credit_note,
                                  reason: item.reason,
                                  modal_view_credit_note: true,
                                });
                              }}
                            />
                            <BtnIcon
                              type="delete"
                              onClick={() => {
                                this.DeleteDebt(item.uid);
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-end">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.setState({
                      amount: 0,
                      count_item: 0,
                      reason: "",
                      status: "",
                      remark: "",
                      transaction_credit_note: transaction_list.map((e) => ({
                        ...e,
                        serial_number: "",
                        credit_qty: 0,
                        credit_unit_price: 0,
                      })),
                      modal_create_credit_note: true,
                    });
                  }}
                >
                  เพิ่มรายการ
                </button>
              </div>
              <div className="rounded-4 bg-white p-3">
                <div className="row">
                  <div className="col-12 col-md-6 mb-2"></div>
                  <div className="col-12 col-md-6 mb-2">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <b>มูลค่าเต็มจำนวนสั่งซื้อ</b>
                      <span>
                        {(() => {
                          let total = 0;
                          transaction_list.forEach((item) => {
                            total +=
                              Number(item.qty) *
                              (Number(item.unit_price) - Number(item.discount));
                          });
                          if (isNaN(total)) total = 0;
                          return `${toFixed(total || 0)} บาท`;
                        })()}
                      </span>
                    </div>
                    {/* <div className="d-flex align-items-center justify-content-between mb-3">
                      <b>มูลค่าชำระแล้ว</b>
                      <span>{toFixed(Number(total_pay))} บาท</span>
                    </div> */}
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <b>หักใบลดหนี้</b>
                      <span>{toFixed(total(credit_note, "amount"))} บาท</span>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <b>มูลค่าที่ถูกต้อง</b>
                      <span>
                        {(() => {
                          let _total = 0;

                          transaction_list.forEach((item) => {
                            const qty = Number(item.qty ?? 0);
                            const unitPrice = Number(item.unit_price ?? 0);
                            const itemDiscount = Number(item.discount ?? 0);
                            _total += qty * (unitPrice - itemDiscount);
                          });

                          if (isNaN(_total)) _total = 0;

                          const billDiscount = Number(discount ?? 0); // ส่วนลดทั้งบิล
                          const net =
                            _total -
                            billDiscount -
                            total(credit_note, "amount");
                          const grandTotal = net;
                          return toFixed(grandTotal);
                        })()}{" "}
                        บาท
                      </span>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <b>ภาษีมูลค่าเพิ่ม 7%</b>
                      <span>
                        {(() => {
                          let _total = 0;
                          const vatRate = is_vat ? 0.07 : 0;

                          transaction_list.forEach((item) => {
                            const qty = Number(item.qty ?? 0);
                            const unitPrice = Number(item.unit_price ?? 0);
                            const itemDiscount = Number(item.discount ?? 0);
                            _total += qty * (unitPrice - itemDiscount);
                          });

                          if (isNaN(_total)) _total = 0;

                          const billDiscount = Number(discount ?? 0); // ส่วนลดทั้งบิล
                          const net =
                            _total -
                            billDiscount -
                            total(credit_note, "amount");
                          const vat = net * vatRate;
                          return toFixed(vat < 0 ? 0 : vat);
                        })()}{" "}
                        บาท
                      </span>
                    </div>
                    <hr />
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <b>มูลค่าที่ต้องชำระ</b>
                      <h4 className="fw-bold text-success">
                        {(() => {
                          let _total = 0;
                          const vatRate = is_vat ? 0.07 : 0;

                          transaction_list.forEach((item) => {
                            const qty = Number(item.qty ?? 0);
                            const unitPrice = Number(item.unit_price ?? 0);
                            const itemDiscount = Number(item.discount ?? 0);
                            _total += qty * (unitPrice - itemDiscount);
                          });

                          if (isNaN(_total)) _total = 0;

                          const billDiscount = Number(discount ?? 0); // ส่วนลดทั้งบิล
                          const net =
                            _total -
                            billDiscount -
                            total(credit_note, "amount");
                          let vat = net * vatRate;
                          vat = vat < 0 ? 0 : vat;
                          const grandTotal = net + vat;
                          return `${toFixed(grandTotal)} บาท`;
                        })()}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="rounded-4 bg-white p-3 mb-3">
            <div className="row">
              <div className="col-12 col-md-6 mb-2">
                <div className="d-flex align-items-center justify-content-between hpx-50">
                  <span>มูลค่าเต็มจำนวนสั่งซื้อ</span>
                  <b>
                    {(() => {
                      let _total = 0;
                      const vatRate = is_vat ? 0.07 : 0;

                      if (transaction_list_vat.length > 0) {
                        transaction_list_vat.forEach((item) => {
                          const qty = Number(item.qty ?? 0);
                          const unitPrice = Number(item.unit_price ?? 0);
                          const itemDiscount = Number(item.discount ?? 0);
                          _total += qty * (unitPrice - itemDiscount);
                        });
                      } else {
                        transaction_list.forEach((item) => {
                          const qty = Number(item.qty ?? 0);
                          const unitPrice = Number(item.unit_price ?? 0);
                          const itemDiscount = Number(item.discount ?? 0);
                          _total += qty * (unitPrice - itemDiscount);
                        });
                      }

                      if (isNaN(_total)) _total = 0;

                      const billDiscount = Number(discount ?? 0); // ส่วนลดทั้งบิล
                      const net =
                        _total - billDiscount - total(credit_note, "amount");
                      const vat = net * vatRate;
                      const grandTotal = net + vat;

                      return `${toFixed(grandTotal)}`;
                    })()}
                  </b>
                </div>
                 <div className="d-flex align-items-center justify-content-between hpx-50">
                        <span>มูลค่าที่ชำระแล้ว</span>
                        <b>
                {toFixed(Number(total_pay))}</b>
                      </div>
                <div className="d-flex align-items-center justify-content-between hpx-50">
                  <span>{(() => {
                      let _total = 0;
                      const vatRate = is_vat ? 0.07 : 0;

                      if (transaction_list_vat.length > 0) {
                        transaction_list_vat.forEach((item) => {
                          const qty = Number(item.qty ?? 0);
                          const unitPrice = Number(item.unit_price ?? 0);
                          const itemDiscount = Number(item.discount ?? 0);
                          _total += qty * (unitPrice - itemDiscount);
                        });
                      } else {
                        transaction_list.forEach((item) => {
                          const qty = Number(item.qty ?? 0);
                          const unitPrice = Number(item.unit_price ?? 0);
                          const itemDiscount = Number(item.discount ?? 0);
                          _total += qty * (unitPrice - itemDiscount);
                        });
                      }

                      if (isNaN(_total)) _total = 0;

                      const billDiscount = Number(discount ?? 0); // ส่วนลดทั้งบิล
                      const net =
                        _total - billDiscount - total(credit_note, "amount");
                      const vat = net * vatRate;
                      const grandTotal = net + vat - Number(total_pay);

                      return grandTotal < 0 ? "ยอดเงินคืนลูกค้า": "มูลค่าค้างชำระ";
                    })()}</span>
                  <b>
                    {(() => {
                      let _total = 0;
                      const vatRate = is_vat ? 0.07 : 0;

                      if (transaction_list_vat.length > 0) {
                        transaction_list_vat.forEach((item) => {
                          const qty = Number(item.qty ?? 0);
                          const unitPrice = Number(item.unit_price ?? 0);
                          const itemDiscount = Number(item.discount ?? 0);
                          _total += qty * (unitPrice - itemDiscount);
                        });
                      } else {
                        transaction_list.forEach((item) => {
                          const qty = Number(item.qty ?? 0);
                          const unitPrice = Number(item.unit_price ?? 0);
                          const itemDiscount = Number(item.discount ?? 0);
                          _total += qty * (unitPrice - itemDiscount);
                        });
                      }

                      if (isNaN(_total)) _total = 0;

                      const billDiscount = Number(discount ?? 0); // ส่วนลดทั้งบิล
                      const net =
                        _total - billDiscount - total(credit_note, "amount");
                      const vat = net * vatRate;
                      const grandTotal = net + vat - Number(total_pay);

                      return `${toFixed(grandTotal)}`;
                    })()}
                  </b>
                </div>
              </div>
              <div className="col-12 col-md-6 mb-2">
                <div className="d-flex align-items-center justify-content-between hpx-50">
                  <span>ชำระมัดจำ</span>
                  <input
                    type="text"
                    className="form-control text-end wpx-200 hpx-40"
                    placeholder="0.00"
                    onChange={(e) => {
                      if (!float(e.target.value)) return;
                      this.setState({ amount_deposit: e.target.value });
                    }}
                    value={amount_deposit}
                    disabled={Number(total_pay) !== 0}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between hpx-50">
                  <span>ยอดเงินที่ต้องการชำระ</span>
                  <input
                    type="text"
                    className="form-control text-end wpx-200 hpx-40"
                    placeholder="0.00"
                    onChange={(e) => {
                      if (!float(e.target.value)) return;
                      this.setState({ amount_deposit_need: e.target.value });
                    }}
                    value={amount_deposit_need}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-5 pb-5">
            {/* ชำระเงินสด */}
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div
                className="rounded-4 bg-white p-3"
                style={{ height: "100%" }}
              >
                <h5 className="fw-bold mb-0">ชำระเงินสด</h5>
                <hr />
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">จำนวนเงิน</span>
                  <input
                    type="text"
                    className="form-control text-end"
                    placeholder="0.00"
                    onChange={(e) => {
                      if (!float(e.target.value)) return;
                      this.setState({ cash_amount: e.target.value });
                    }}
                    value={cash_amount}
                  />
                </div>
                {/* <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">เงินทอน</span>
                  <b>{toFixed(cash_amount || 0)} บาท</b>
                </div> */}
              </div>
            </div>
            {/* ชำระเงินโอน */}
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div
                className="rounded-4 bg-white p-3"
                style={{ height: "100%" }}
              >
                <h5 className="fw-bold mb-0">ชำระเงินโอน</h5>
                <hr />
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">จำนวนเงิน</span>
                  <input
                    type="text"
                    className="form-control text-end"
                    placeholder="0.00"
                    onChange={(e) => {
                      if (!float(e.target.value)) return;
                      this.setState({ transfer_amount: e.target.value });
                    }}
                    value={transfer_amount}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">บัญชีธนาคาร</span>
                  <Select
                    options={data_bank}
                    className="form-control"
                    onChange={(e) => {
                      this.setState({ transfer_bank_account: e });
                    }}
                    value={transfer_bank_account}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">วันที่โอน</span>
                  <DatePicker
                    className="form-control"
                    onChange={(e) => {
                      this.setState({ transfer_date: e });
                    }}
                    value={transfer_date}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">เวลาที่โอน</span>
                  <input
                    type="time"
                    className="form-control"
                    onChange={(e) => {
                      this.setState({ transfer_time: e.target.value });
                    }}
                    value={transfer_time}
                  />
                </div>
              </div>
            </div>
            {/* ชำระเช็ค */}
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div
                className="rounded-4 bg-white p-3"
                style={{ height: "100%" }}
              >
                <h5 className="fw-bold mb-0">ชำระเช็ค</h5>
                <hr />
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">จำนวนเงิน</span>
                  <input
                    type="text"
                    className="form-control text-end"
                    placeholder="0.00"
                    onChange={(e) => {
                      if (!float(e.target.value)) return;
                      this.setState({ credit_amount: e.target.value });
                    }}
                    value={credit_amount}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">บัญชีธนาคาร</span>
                  <Select
                    options={global.bank}
                    className="form-control"
                    onChange={(e) => {
                      this.setState({ credit_bank_account: e });
                    }}
                    value={credit_bank_account}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">วันที่หน้าเช็ค</span>
                  <DatePicker
                    className="form-control"
                    onChange={(e) => {
                      this.setState({ credit_date: e });
                    }}
                    value={credit_date}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">เลขที่เช็ค</span>
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) => {
                      if (!float(e.target.value)) return;
                      this.setState({ check_number: e.target.value });
                    }}
                    value={check_number}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="position-fixed w-100 bg-white d-flex justify-content-end p-3"
          style={{ bottom: 0, left: 0 }}
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              this.CreateUpdate();
            }}
          >
            รับชำระ
          </button>
        </div>

        {/* CREATE UPDATE */}
        <Modal
          show={modal_create_credit_note}
          onHide={() => this.setState({ modal_create_credit_note: false })}
          fullscreen={true}
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">เพิ่มใบลดหนี้</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td>
                      {" "}
                      <input
                        type="checkbox"
                        checked={transaction_credit_note.every(
                          (e) => e.checked
                        )}
                        onChange={(e) => {
                          this.setState({
                            transaction_credit_note:
                              transaction_credit_note.map((t) => ({
                                ...t,
                                checked: e.target.checked,
                              })),
                          });
                        }}
                      />
                    </td>
                    <td className="text-nowrap">รหัส/ชื่อสินค้า</td>
                    <td className="text-nowrap">SerialNo</td>
                    <td className="text-nowrap text-center">จำนวน</td>
                    <td className="text-nowrap text-center">ราคา/หน่วย</td>
                    <td className="text-nowrap text-center">จำนวนที่ลดหนี้</td>
                    <td className="text-nowrap text-center">
                      ราคา/หน่วยที่ลดหนี้
                    </td>
                    <td className="text-nowrap text-end">มูลค่ารวม</td>
                  </tr>
                </thead>
                <tbody>
                  {transaction_credit_note?.map((item, index) => (
                    <tr>
                      <td>
                        {" "}
                        <input
                          type="checkbox"
                          checked={item.checked}
                          onChange={(e) => {
                            transaction_credit_note[index].checked =
                              e.target.checked;
                            transaction_credit_note[index].credit_qty = 0;
                            transaction_credit_note[index].credit_unit_price = e
                              .target.checked
                              ? item.unit_price
                              : 0;
                            this.setState({
                              transaction_credit_note: transaction_credit_note,
                            });
                          }}
                        />
                      </td>
                      <td className="text-nowrap">
                        {item.product_code} {item.product_name}
                      </td>
                      <td className="text-nowrap">
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            transaction_credit_note[index].serial_number =
                              e.target.value;
                            this.setState({ transaction_credit_note });
                          }}
                          value={item.serial_number}
                          disabled={item.credit_qty === 0}
                        />
                      </td>
                      <td className="text-nowrap">{item.qty}</td>
                      <td className="text-nowrap">
                        {toFixed(item.unit_price)}
                      </td>
                      <td className="text-nowrap">
                        <div className="d-flex">
                          <button
                            className="btn btn-primary wpx-30"
                            disabled={!item.checked}
                            onClick={async () => {
                              if (item.credit_qty <= 1) {
                                transaction_credit_note[index].credit_qty = 0;
                                transaction_credit_note[index].serial_number =
                                  "";
                                this.setState({
                                  transaction_credit_note:
                                    transaction_credit_note,
                                });
                              } else {
                                transaction_credit_note[index].credit_qty =
                                  Math.max(0, item.credit_qty - 1);
                                this.setState({ transaction_credit_note });
                              }
                            }}
                          >
                            -
                          </button>
                          <input
                            type="text"
                            className="form-control wpx-60 mx-1 text-center"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              transaction_credit_note[index].credit_qty =
                                Number(e.target.value);
                              if (Number(e.target.value) === 0) {
                                transaction_credit_note[index].serial_number =
                                  "";
                              }
                              this.setState({ transaction_credit_note });
                            }}
                            value={item.credit_qty}
                            disabled={!item.checked}
                          />
                          <button
                            className="btn btn-primary wpx-30"
                            disabled={!item.checked}
                            onClick={() => {
                              if (item.credit_qty >= item.qty) {
                                return;
                              }
                              transaction_credit_note[index].credit_qty =
                                Math.max(0, item.credit_qty + 1);
                              this.setState({ transaction_credit_note });
                            }}
                          >
                            +
                          </button>
                        </div>
                      </td>
                      <td className="text-nowrap">
                        <input
                          type="text"
                          className="form-control wpx-100 mx-1 text-end"
                          onChange={(e) => {
                            if (!float(e.target.value)) return;
                            if (
                              Number(item.unit_price) < Number(e.target.value)
                            ) {
                              e.target.value = Number(item.unit_price);
                            }
                            transaction_credit_note[index].credit_unit_price =
                              e.target.value;
                            this.setState({ transaction_credit_note });
                          }}
                          value={item.credit_unit_price}
                          disabled={!item.checked}
                        />
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(Number(item.credit_unit_price) * Number(item.credit_qty)) || "0.00"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-end">
              <div className="d-flex mb-3">
                <b className="wpx-100">มูลค่าค้างชำระ</b>
                <h4 className="fw-bold text-success">
                  {(() => {
                    let _total = 0;
                    transaction_credit_note.forEach((item) => {
                      const creditUnitPrice = Number(
                        item.credit_unit_price ?? 0
                      ) * item.credit_qty;
                      const unitPrice = Number(item.unit_price ?? 0) * item.qty;
                      _total += unitPrice - creditUnitPrice;
                    });
                    return toFixed(_total);
                  })()}
                </h4>
              </div>
            </div>
            <hr />
            <div className="mb-3">เหตุผลการลดหนี้</div>
            <textarea
              className="form-control mb-3"
              rows={5}
              onChange={(e) => {
                this.setState({ reason: e.target.value });
              }}
              value={reason}
            />
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                   if(transaction_credit_note.filter(e=>e.checked && Number(e.credit_unit_price) === 0).length > 0){
                                       alert("","warning","แจ้งเตือน","กรุณากรอกราคา/หน่วยที่ลดหนี้ให้ครบ");
                                      return;
                                    }
                  this.CreateUpdateCreditNote();
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_create_credit_note: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        <Modal
          show={modal_view_credit_note}
          onHide={() => this.setState({ modal_view_credit_note: false })}
          size="lg"
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">รายการใบลดหนี้</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">รหัส/ชื่อสินค้า</td>
                    <td className="text-nowrap text-center">จำนวนที่ลดหนี้</td>
                    <td className="text-nowrap text-end">
                      ราคา/หน่วยที่ลดหนี้
                    </td>
                    <td className="text-nowrap text-end">มูลค่ารวม</td>
                  </tr>
                </thead>
                <tbody>
                  {transaction_credit_note?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">
                        {item.product_code} {item.product_name}
                      </td>
                      <td className="text-nowrap text-center">
                        {item.qty || ""}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(item.unit_price)}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(Number(item.qty) * Number(item.unit_price)) ||
                          "0.00"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-end">
              <div className="d-flex mb-3">
                <b className="wpx-100">มูลค่าค้างชำระ</b>
                <h4 className="fw-bold text-success">
                  {(() => {
                    let _total = 0;
                    transaction_credit_note.forEach((item) => {
                      const qty = Number(item.qty ?? 0);
                      const unitPrice = Number(item.unit_price ?? 0);
                      _total += qty * unitPrice;
                    });
                    return toFixed(_total);
                  })()}
                </h4>
              </div>
            </div>
            <hr />
            <div className="mb-3">เหตุผลการลดหนี้</div>
            <p>{reason}</p>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
